import instance from "./instance"
import login from "./login"
import creat from "./creat"
import query from "./query"
import update from "./update"
import delet from "./delete"

export default {
  instance,
  login,
  creat,
  query,
  update,
  delet
}
